<div class="modal fade" id="selectOfferModal" tabindex="-1" role="dialog" aria-labelledby="selectOfferModalTitle"
	data-keyboard="false" data-backdrop="static" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
		<div class="modal-content">
			<div class="modal-body">
				<div id="select-offers-carousel" class="carousel slide" data-interval="false">
					<div class="carousel-inner">
						<div class="carousel-item active">
							<div class="d-flex flex-column">
								<h5 class="selected-offers-title">
									Select your payment options below
								</h5>
								<div class="flex-grow-1 d-flex align-items-center">
									<div class="w-100">
										<table class="table table-striped table-hover">
											<thead class="thead-dark">
												<tr>
													<th scope="col">Term</th>
													<th scope="col">Amount</th>
													<th scope="col">Payment</th>
													<th scope="col">Selected</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let offer of offers.offerList; let i = index">
													<th scope="row"> {{offer.term}} </th>
													<td> {{ (offer.useMaxApprovedAmount ? offers.maxApproved : offers.requestAmount) | currency:'$ ':'code':'.0-0'}}
													</td>
													<td> {{ offer.payment | currency:'$ ':'code':'.2-2' }} </td>
													<td>
														<input type="radio" id="selected-offer{{i}}"
															value="{{offer.offerId}}" [formControl]="selectedOfferRadio"
															name="selected-offer">
													</td>
												</tr>
											</tbody>
										</table>
										<h4>ACH Payments are required for all transactions</h4>
										<div class="terms-support">
											If you have any questions about the payment or terms of the transaction, please call us at: 888-555-5555. If you'd like us to call you, please click
											<a routerLink="/support" data-dismiss="modal">HERE</a>
										</div>
									</div>
								</div>
								<div class="container select-offer-dialog-footer">
									<div class="row justify-content-end">
										<button type="button"
											class="btn btn-lg btn-secondary col-xl-3 col-lg-5 col-md-5"
											(click)="onBackFromOffersClick();">Back</button>
										<button type="button"
											class="btn btn-lg btn-primary col-xl-3 col-lg-5 col-md-5 offset-xl-6 offset-lg-2 offset-md-2"
											(click)="onContinueFromOffersClick();">Continue</button>
									</div>
								</div>
							</div>
						</div>
						<div class="carousel-item">
							<div class="d-flex flex-column">
								<h5 class="selected-offers-title">
									SUMMARY OF TERMS
								</h5>
								<div class="container body flex-grow-1 d-flex align-items-center">
									<div>
										<div class="row">
											<div class="agreement-container col-xl-4">
												<div class="agreement-title">Amount Due Today</div>
												<div class="agreement-value">$ {{invoiceDueToday + offers.amountDueToday}}</div>
												<div class="agreement-description">
													Actual ACH date may vary based on equipment delivery/availability
												</div>
											</div>
											<div class="agreement-container col-xl-4">
												<div class="agreement-title">Monthly Payment</div>
												<div class="agreement-value">$ {{selectedOffer.payment}}</div>
												<div class="agreement-description">Plus Applicable Taxes</div>
											</div>
											<div class="agreement-container col-xl-4">
												<div class="agreement-title">Term</div>
												<div class="agreement-value">{{selectedOffer.term}} months</div>
												<div class="agreement-description">Including Purchase Option</div>
											</div>
										</div>
									</div>
								</div>
								<div class="container select-offer-dialog-footer">
									<div class="row justify-content-end">
										<button type="button"
											class="btn btn-lg btn-secondary col-xl-3 col-lg-5 col-md-5"
											(click)="onBackFromSummaryClick();">Back</button>
										<button type="button"
											class="btn btn-lg btn-primary col-xl-3 col-lg-5 col-md-5 offset-xl-6 offset-lg-2 offset-md-2"
											(click)="onContinueFromSummaryClick();">Continue</button>
									</div>
								</div>
							</div>
						</div>
						<div class="carousel-item">
							<div class="d-flex flex-column">
								<h5 class="selected-offers-title">
									APPLICATION AMENDMENT
								</h5>
								<div class="container body flex-grow-1 d-flex align-items-center content-box">
									<div class="row w-100">
										<div class="agreement-container col-lg-10 offset-lg-1 col-12">
											<div class="agreement-title">CAUTION</div>
											<div class="agreement-value">This action will create an amendment</div>
											<div class="agreement-description">This action will create an amendment, do you want to continue?</div>
										</div>
									</div>
								</div>
								<div class="container select-offer-dialog-footer">
									<div class="row justify-content-end">
										<button type="button"
											class="btn btn-lg btn-secondary col-xl-3 col-lg-5 col-md-5"
											(click)="onBackFromAmendmentClick();">Back</button>
										<button type="button"
											class="btn btn-lg btn-primary col-xl-3 col-lg-5 col-md-5 offset-xl-6 offset-lg-2 offset-md-2"
											(click)="onContinueFromAmendmentClick();">Continue</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>